// src/pages/AboutPage.jsx
import React from "react";
import { Link } from "react-router-dom";
import Navigation from "../components/Common/header/Navigation";
import Footer from "../components/Common/footer/Footer";
import "../styles/Pages.css";

const AboutPage = () => {
    return (
        <div className="page-shell">
            <Navigation />

            {/* ── Hero ── */}
            <section className="page-hero">
                <div className="page-hero-border" />
                <div className="container" style={{ position: "relative", zIndex: 1 }}>
                    <span className="page-hero-eyebrow">Our Story</span>
                    <h1 className="page-hero-title">About Bundle Madness</h1>
                    <p className="page-hero-subtitle">
                        Why settle for average when luxury hair is within reach?
                    </p>
                    <p className="page-hero-subtitle" style={{ fontSize: "0.8rem", letterSpacing: "3px", marginTop: "8px" }}>
                        Elevating tradition. Proclaiming opulence.
                    </p>
                    <div className="page-hero-rule" />
                </div>
            </section>

            {/* ── About Body ── */}
            <section className="page-section">
                <div className="container">
                    <h2 className="page-section-title"> Made for the Madness</h2>
                    <p className="page-section-subtitle">Premium Burmese hair, pure in every strand</p>

                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                        gap: "40px",
                        alignItems: "center",
                        marginTop: "40px"
                    }}>
                        {/* Left Side: The Image */}
                        <div>
                            <img
                                src="https://i.ibb.co/xtb4mSzk/93a496c4-eadc-41b9-9442-61f4f2a61e1f.jpg"
                                alt="Bundle Madness Quality Hair"
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    borderRadius: "4px",
                                    border: "1px solid rgba(212, 175, 55, 0.2)",
                                    boxShadow: "0 10px 30px rgba(0,0,0,0.5)"
                                }}
                            />
                        </div>

                        {/* Right Side: The Text */}
                        <div className="page-prose">
                            <p>
                                Bundle Madness was created from a genuine love for hair and the way it has the ability to transform not only your appearance,
                                but also the way you feel. Over time, I realised that changing my hairstyle often brought a renewed sense of confidence, expression, and self-assurance.
                                What began as a personal love for different hairstyles, eventually  became the inspiration behind Bundle Madness.
                            </p>
                            <p>
                                The brand was created for those who understand that hair is more than just an accessory. It is a form of self-expression, confidence, creativity, and individuality.
                                Whether it’s a sleek look, voluminous curls, or a bold new colour, hair has a way of allowing you to embrace different versions of yourself.
                                Our mission is centred around “Made for the Madness” — a concept that celebrates the emotions and experiences that come with a genuine love for hair;
                                the confidence boost, the compliments, and all the little moments in between that make you feel like the best version of yourself.
                            </p>
                            <p>
                                We specialise high-quality Burmese human hair, carefully selected luxury textures designed to offer softness, versatility, and lasting quality. However, Bundle Madness extends beyond the bundles themselves.
                                Every detail of the brand is intended to create a distinctive experience that feels elevated, and authentic from beginning to end.
                            </p>
                            <p>At Bundle Madness, we believe hair transcends beyond appearance. It’s really about how you feel when you wear it.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Collections ── */}
            <section className="page-section page-section--raised">
                <div className="container">
                    <h2 className="page-section-title">Our Collections</h2>
                    <p className="page-section-subtitle">Discover our premium hair bundles</p>

                    <div className="collection-grid">
                        <div className="collection-card">
                            <i className="fas fa-palette" />
                            <h4>Coloured Bundles</h4>
                            <p>Vibrant colours for every style</p>
                        </div>
                        <div className="collection-card">
                            <i className="fas fa-crown" />
                            <h4>Frontals &amp; Closures</h4>
                            <p>Perfect finishing touches</p>
                        </div>
                        <div className="collection-card">
                            <i className="fas fa-gem" />
                            <h4>Pure Madness</h4>
                            <p>Shop raw hair — pure in every strand</p>
                        </div>
                    </div>

                    <div style={{ textAlign: "center", marginTop: "48px" }}>
                        <Link to="/shop" className="btn-luxury">
                            <span>Explore All Collections</span>
                        </Link>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default AboutPage;